/**
 * Whether the root layout should render a route BARE — no AppShell (no navbar /
 * subnav). True for:
 *  - an unmatched path (only the root match is present) → the 404 page,
 *  - a matched route that threw `notFound()` (e.g. a missing / cross-tenant
 *    vault document) → the same standalone 404, so it reveals no section chrome,
 *  - `/suspended`, which must make no authed API calls.
 *
 * `status` / `globalNotFound` come from TanStack Router's match objects; a global
 * `notFound()` sets `globalNotFound` on the owning match while a route-level one
 * sets `status === 'notFound'` — cover both.
 */
export function shouldRenderBare(
  matches: ReadonlyArray<{ status?: string; globalNotFound?: boolean }>,
  pathname: string,
): boolean {
  return (
    matches.length <= 1 ||
    matches.some((m) => m.status === 'notFound' || m.globalNotFound === true) ||
    pathname === '/suspended'
  );
}
